/* ppz-offer.js — l'interruttore acquisto singolo / abbonamento della landing.
 *
 * Contratto: la sezione porta data-ppz-offer. Dentro:
 *   [data-ppz-offer-tick]    la casella-barretta: commuta.
 *   [data-ppz-offer-set]     i due bottoni ai lati, value "once" o "sub":
 *                            SCELGONO, non commutano. Non vanno fatti a
 *                            etichetta: un'etichetta commuta, e cliccando
 *                            "acquisto singolo" quando era gia' spento si
 *                            riaccendeva l'abbonamento (bug del 04/09/2026).
 *   [data-ppz-card]          una per confezione. Ha negli attributi data-* i
 *                            prezzi GIA' FORMATTATI dal filtro money del
 *                            Liquid: qui non si formattano valute a mano, si
 *                            scambiano stringhe pronte. Serve a non sbagliare
 *                            simbolo, separatori e posizione della valuta
 *                            quando il negozio cambia paese.
 *   [data-ppz-kit]           il prezzo per confezione
 *   [data-ppz-total]         il totale
 *   [data-ppz-full]          il totale barrato
 *   [data-ppz-save]          quanto si risparmia
 *   [data-ppz-plan]          l'input nascosto "selling_plan"
 *
 * Nessuna chiamata di rete: tutti i prezzi sono gia' in pagina.
 */
(function () {
  function init(root) {
    if (root.dataset.ppzOffer === 'ready') return;
    root.dataset.ppzOffer = 'ready';

    var tick = root.querySelector('[data-ppz-offer-tick]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ppz-card]'));
    if (!cards.length) return;

    /* Senza casella l'abbonamento non e' previsto: acquisto singolo. */
    function wantsSub() { return !!(tick && tick.checked); }

    function put(card, sel, value) {
      var el = card.querySelector(sel);
      if (el && value != null) el.textContent = value;
    }

    function apply(sub) {
      cards.forEach(function (card) {
        var p = sub ? 'data-sub-' : 'data-once-';

        put(card, '[data-ppz-kit]', card.getAttribute(p + 'kit'));
        put(card, '[data-ppz-total]', card.getAttribute(p + 'total'));
        put(card, '[data-ppz-full]', card.getAttribute(p + 'full'));
        put(card, '[data-ppz-save]', card.getAttribute(p + 'save'));

        /* Il prezzo barrato e la riga del risparmio hanno senso solo se si
           risparmia davvero: a sconto zero sparirebbero due bugie. */
        var hasSave = card.getAttribute(p + 'has-save') === '1';
        var full = card.querySelector('[data-ppz-full]');
        var save = card.querySelector('[data-ppz-save-wrap]');
        if (full) full.hidden = !hasSave;
        if (save) save.hidden = !hasSave;

        /* L'input selling_plan va DISATTIVATO sull'acquisto singolo: un input
           disabilitato non viene inviato, quindi il carrello riceve un acquisto
           normale e non un abbonamento. */
        var plan = card.querySelector('[data-ppz-plan]');
        if (plan) {
          var planId = card.getAttribute('data-plan-id') || '';
          var wants = sub && planId !== '';
          plan.value = wants ? planId : '';
          plan.disabled = !wants;
        }
      });

      root.setAttribute('data-mode', sub ? 'sub' : 'once');

      /* I bottoni dicono quale dei due e' scelto: serve ai lettori di schermo
         e ai due riquadri col pallino (05/10/2026), che si colorano da qui. */
      Array.prototype.slice.call(root.querySelectorAll('[data-ppz-offer-set]'))
        .forEach(function (btn) {
          var suo = btn.getAttribute('data-ppz-offer-set') === 'sub';
          btn.setAttribute('aria-pressed', suo === sub ? 'true' : 'false');
        });
    }

    if (tick) {
      tick.addEventListener('change', function () { apply(wantsSub()); });
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-ppz-offer-set]'))
      .forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sub = btn.getAttribute('data-ppz-offer-set') === 'sub';
          if (tick) tick.checked = sub;
          /* Si chiama apply direttamente: cambiare `checked` da codice NON fa
             partire l'evento change, quindi aspettarlo non servirebbe a nulla. */
          apply(sub);
        });
      });

    /* Ultimo controllo un attimo prima di partire, come sulla scheda prodotto
       (ppz-buybox.js): se il JavaScript dell'app degli abbonamenti ha scritto un
       piano nel modulo, qui torna la scelta del cliente e ogni campo altrui
       sparisce. Con l'abbonamento spento dal tema non c'e' la casella, quindi
       il piano non parte mai (24/09/2026). */
    cards.forEach(function (card) {
      var f = card.querySelector('form');
      if (!f) return;
      f.addEventListener('submit', function () {
        var planId = card.getAttribute('data-plan-id') || '';
        var wants = wantsSub() && planId !== '';
        Array.prototype.slice.call(f.querySelectorAll('[name="selling_plan"]'))
          .forEach(function (el) {
            if (el.hasAttribute('data-ppz-plan')) {
              el.value = wants ? planId : '';
              el.disabled = !wants;
            } else if (el.parentNode) {
              el.parentNode.removeChild(el);
            }
          });
      });
    });

    apply(wantsSub());
  }

  function boot() {
    document.querySelectorAll('[data-ppz-offer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

/* Il conto alla rovescia della riga sotto il titolo (24/09/2026).
 * [data-ppz-countdown] mostra quanto manca alle 23:59:59 di oggi in ORA
 * ITALIANA, non quella del telefono: chi ha un altro fuso vede la stessa
 * scadenza. A mezzanotte riparte da 23:59:59. Il Liquid scrive gia' un valore,
 * ma la pagina puo' arrivare dalla cache: qui si corregge al primo giro.
 * Un solo orologio per pagina; gli elementi si cercano a ogni secondo, cosi'
 * funziona anche dopo che l'editor ha ricaricato la sezione. */
(function () {
  if (window.ppzCountdown) return;
  window.ppzCountdown = true;

  var fmt = null;
  try {
    fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Rome', hourCycle: 'h23',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
  } catch (e) {}

  function secondiDiOggi() {
    var d = new Date();
    if (!fmt || !fmt.formatToParts) return d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();
    var v = {};
    fmt.formatToParts(d).forEach(function (p) { v[p.type] = parseInt(p.value, 10); });
    return (v.hour % 24) * 3600 + v.minute * 60 + v.second;
  }

  function due(n) { return (n < 10 ? '0' : '') + n; }

  /* Un pezzo solo (12/10/2026, i riquadri «Ore / Minuti / Secondi» di
     ppz-lp-last): data-ppz-countdown="h", "m" oppure "s" riceve solo le sue
     due cifre. Senza valore, come prima, tutto «hh:mm:ss». */
  function scorri() {
    var r = Math.max(0, 86399 - secondiDiOggi());
    var p = { h: due(Math.floor(r / 3600)), m: due(Math.floor((r % 3600) / 60)), s: due(r % 60) };
    var t = p.h + ':' + p.m + ':' + p.s;
    document.querySelectorAll('[data-ppz-countdown]').forEach(function (el) {
      var v = p[el.getAttribute('data-ppz-countdown')] || t;
      if (el.textContent !== v) el.textContent = v;
    });
  }

  scorri();
  setInterval(scorri, 1000);
})();
